import { Button, ConfigProvider, Form } from "antd";
import { LocalContext } from "context/AuthenticationContext";
import isEmpty from "lodash/isEmpty";
import isUndefined from "lodash/isUndefined";
import { ContextType, PureComponent, ReactNode } from "react";
import { ClassFormat } from "utils/format/ClassFormat";
import { colorFormat } from "utils/format/ColorFormat";
import { findFeature } from "utils/format/FeatureFormat";
import { strings } from "utils/localizedStrings";
import {
  IActionButtonState,
  IActionComponentButton,
} from "./interface/IActionButtonComponent";

export default class ActionButtonComponent extends PureComponent<
  IActionComponentButton,
  IActionButtonState
> {
  static contextType = LocalContext;
  context!: ContextType<typeof LocalContext>;
  constructor(props: IActionComponentButton) {
    super(props);
    this.state = {
      buttonLoading: false,
      deleteLoading: false,
    };
  }

  render(): ReactNode {
    const { buttonProps, buttonInFormProps, children } = this.props?.data;
    const { buttonLoading, deleteLoading } = this.state;
    return (
      <div className="flex justify-center items-center gap-1">
        {buttonInFormProps
          ?.filter((element) => !isUndefined(element) && !isEmpty(element))
          ?.map((item, index) => {
            const isAllowed =
              !item?.isFollowingFeature ||
              (item?.isFollowingFeature === true &&
                findFeature(item?.featurePath));
            if (!isAllowed) return null;

            return (
              <ConfigProvider
                key={`${item?.label ?? "form-action"}-${index}`}
                theme={{
                  token: {
                    colorPrimary: !!item?.colorPrimary
                      ? item?.colorPrimary
                      : colorFormat?.Blue,
                  },
                }}
              >
                <Form.Item>
                  <Button
                    htmlType={item?.htmlType}
                    loading={
                      item?.loading
                        ? item?.loading
                        : item?.htmlType === "submit" && item?.loading
                          ? buttonLoading
                          : false
                    }
                    type={item?.type}
                    style={item?.style}
                    size="small"
                    className={
                      item?.className || ClassFormat.actionButtonFormat
                    }
                    onClick={async () => {
                      item?.htmlType !== "submit" &&
                        this.setState({
                          buttonLoading: true,
                        });
                      !!item?.onClick &&
                        item?.htmlType !== "submit" &&
                        (await (item?.onClick() as Promise<void>));
                    }}
                    icon={item?.icon}
                    iconPosition="end"
                  >
                    {item?.label ? item?.label : ""}
                  </Button>
                </Form.Item>
              </ConfigProvider>
            );
          })}
        {buttonProps
          ?.filter((child) => child !== undefined)
          ?.map((item, index) => {
            const isAllowed =
              !item?.isFollowingFeature ||
              (item?.isFollowingFeature === true &&
                findFeature(item?.featurePath));
            if (!isAllowed) return null;

            return (
              <Button
                key={`${item?.label}${index}`}
                shape="circle"
                size={"small"}
                disabled={
                  item?.label === strings.GlobalLabels.Deleted
                    ? deleteLoading
                    : buttonLoading
                }
                type={item?.type ?? "link"}
                danger={
                  item?.label === strings.GlobalLabels.Deleted ? true : false
                }
                style={{
                  color: item?.colorPrimary,
                }}
                className={item?.className}
                onClick={async () => {
                  item?.label === strings.GlobalLabels.Deleted
                    ? this.setState({
                      deleteLoading: true,
                    })
                    : this.setState({
                      buttonLoading: true,
                    });
                  await (item?.onClick() as Promise<void>).finally(() => {
                    this.setState({
                      buttonLoading: false,
                      deleteLoading: false,
                    });
                  });
                }}
                icon={item?.icon}
                iconPosition="end"
              >
                {item?.label ? item?.label : ""}
              </Button>
            );
          })}
        {children ?? <></>}
      </div>
    );
  }
}
